import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { EventBrokerService, EventTypeInterface } from '@vendasta/event-broker';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, map, take } from 'rxjs/operators';

@Component({
  selector: 'app-loop-event-selector',
  styleUrls: ['./event-selector.component.scss'],
  templateUrl: './event-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventSelectorComponent implements OnInit {
  private loading$$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  loading$: Observable<boolean> = this.loading$$.asObservable();
  private cursor: string;
  hasMore: boolean;
  private events$$: BehaviorSubject<EventTypeInterface[]> = new BehaviorSubject([]);
  events$: Observable<EventTypeInterface[]> = this.events$$.asObservable();

  constructor(public eventBrokerService: EventBrokerService) {}

  ngOnInit(): void {
    this.loadMoreEvents();
  }

  loadMoreEvents(): void {
    this.loading$$.next(true);
    this.eventBrokerService
      .listEventTypes(this.cursor, 30)
      .pipe(
        map((results) => {
          this.hasMore = results.hasMore;
          this.cursor = results.nextCursor;
          this.events$$.next(this.events$$.getValue().concat(results.eventTypes));
        }),
        finalize(() => this.loading$$.next(false)),
        take(1),
      )
      .subscribe();
  }
}
